import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon69: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 18.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 18" width={width} height={height} {...props}>
      <Path
        d="M2.5 0C2.681 0 2.849 0.0979885 2.937 0.256989L4.464 2.99899L18.575 3C19.572 3 20.253 3.98399 19.91 4.95099L19.86 5.077L16.878 10.028C16.516 10.631 15.864 11 15.16 11H8.963C8.787 11 8.61501 10.977 8.44901 10.932C8.50301 11.72 8.319 12.521 7.901 13.21L7.282 14.232C7.648 14.392 7.957 14.662 8.166 14.999H15.352C15.699 14.44 16.318 14.067 17.025 14.067C18.11 14.067 18.99 14.948 18.99 16.033C18.99 17.119 18.11 17.999 17.025 17.999C15.939 17.999 15.059 17.119 15.059 16.033V15.999H8.459C8.459 16.011 8.459 16.022 8.459 16.033C8.459 17.119 7.579 17.999 6.494 17.999C5.408 17.999 4.52699 17.119 4.52699 16.033C4.52699 15.048 5.25201 14.232 6.19701 14.09L7.045 12.692C7.577 11.815 7.597 10.681 7.097 9.78101L4.476 5.077L3.73399 3.75101C3.72399 3.73301 3.714 3.714 3.705 3.694V3.69199L2.20599 1H0.5C0.224 1 0 0.776 0 0.5C0 0.224 0.224 0 0.5 0H2.5ZM17.025 15.067C16.492 15.067 16.059 15.5 16.059 16.033C16.059 16.567 16.492 16.999 17.025 16.999C17.557 16.999 17.99 16.567 17.99 16.033C17.99 15.5 17.557 15.067 17.025 15.067ZM6.494 15.067C5.96 15.067 5.528 15.5 5.528 16.033C5.528 16.567 5.96 16.999 6.494 16.999C7.026 16.999 7.45799 16.567 7.45799 16.033C7.45799 15.5 7.026 15.067 6.494 15.067ZM18.575 4L5.021 3.99899L5.481 4.82501L8.101 9.51001C8.259 9.77501 8.53 9.951 8.832 9.991L8.963 10H15.16C15.512 10 15.839 9.815 16.02 9.513L18.974 4.617C19.103 4.326 18.891 4 18.575 4Z"
        fill="#404040"
      />
    </Icon>
  )
}
